import { createVNode as _createVNode } from "vue";
/**
 * @author chenjizhong
 * @fileoverview 赛事荣誉榜 - 路由页面
 */

import { defineComponent } from "vue";
// components
import PcBox from "@/components/pc/race-honors.vue";
import MBox from "@/components/m/race-honors.vue";
export default defineComponent({
  name: "RaceHonors",
  setup() {
    return () => {
      return window.screen.width < 1200 ? _createVNode(MBox, null, null) : _createVNode(PcBox, null, null);
    };
  }
});